import { frFR, enUS, roRO } from '@mui/x-date-pickers/locales';
import 'dayjs/locale/fr';
import 'dayjs/locale/ro';
import 'dayjs/locale/en';

export const ROLE_SUPER_ADMIN = 50;
export const ROLE_ADMIN = 40;
export const ROLE_TECHNICIAN = 30;
export const ROLE_FARMER = 20;
export const ROLE_USER = 10;

export const mainNav = [
  {
    id: 0,
    text: 'navigation.administration',
    path: 'administration',
    minimalRole: ROLE_SUPER_ADMIN,
  },
  {
    id: 1,
    text: 'navigation.cooperative',
    path: 'cooperative',
    minimalRole: ROLE_ADMIN,
  },
  { id: 2, text: 'navigation.sectors', path: 'sector', minimalRole: ROLE_TECHNICIAN },
  {
    id: 3,
    text: 'navigation.exploitations',
    path: 'exploitation',
    minimalRole: ROLE_FARMER,
  },
];

export const routing = {
  administration: [
    {
      path: 'administration/Cooperative',
      text: 'navigation.structures',
      minimalRole: ROLE_SUPER_ADMIN,
    },
    { path: 'administration/tools', text: 'navigation.tools', minimalRole: ROLE_SUPER_ADMIN },
    {
      path: 'administration/accessRights',
      text: 'navigation.accessRights',
      minimalRole: ROLE_SUPER_ADMIN,
    },
    {
      path: 'administration/contraintes',
      text: 'common.constraints',
      minimalRole: ROLE_SUPER_ADMIN,
    },
  ],
  cooperative: [
    { path: 'cooperative/sectors', text: 'navigation.sectors', minimalRole: ROLE_ADMIN },
    { path: 'cooperative/technicians', text: 'navigation.technicians', minimalRole: ROLE_ADMIN },
    { path: 'cooperative/cultures', text: 'common.cultures', minimalRole: ROLE_ADMIN },
    { path: 'cooperative/groundTypes', text: 'navigation.groundTypes', minimalRole: ROLE_ADMIN },
    {
      path: 'cooperative/rotateEffects',
      text: 'navigation.rotationEffects',
      minimalRole: ROLE_ADMIN,
    },
    {
      path: 'cooperative/groundTypesEffects',
      text: 'navigation.groundTypeEffects',
      minimalRole: ROLE_ADMIN,
    },
    { path: 'cooperative/cultureGroup', text: 'navigation.cultureGroup', minimalRole: ROLE_ADMIN },
    {
      path: 'cooperative/contstaints',
      text: 'navigation.coProductConstraints',
      minimalRole: ROLE_ADMIN,
    },
    { path: 'cooperative/import', text: 'navigation.import', minimalRole: ROLE_ADMIN },
  ],
  sector: [
    { path: 'sector', text: 'navigation.sectors', minimalRole: ROLE_TECHNICIAN },
    {
      path: 'sector/exploitations',
      text: 'navigation.exploitations',
      minimalRole: ROLE_TECHNICIAN,
    },
    { path: 'sector/cultures', text: 'common.cultures', minimalRole: ROLE_TECHNICIAN },
    {
      path: 'sector/rotateEffects',
      text: 'navigation.rotationEffects',
      minimalRole: ROLE_TECHNICIAN,
    },
    {
      path: 'sector/groundTypesEffects',
      text: 'navigation.groundTypeEffects',
      minimalRole: ROLE_TECHNICIAN,
    },
    { path: 'sector/cultureGroup', text: 'navigation.cultureGroup', minimalRole: ROLE_TECHNICIAN },
    { path: 'sector/import', text: 'navigation.import', minimalRole: ROLE_TECHNICIAN },
  ],
  exploitation: [
    { path: 'exploitation', text: 'navigation.exploitations', minimalRole: ROLE_FARMER },
    { path: 'exploitation/parcels', text: 'common.parcels', minimalRole: ROLE_FARMER },
    { path: 'exploitation/cultures', text: 'common.cultures', minimalRole: ROLE_FARMER },
    {
      path: 'exploitation/rotateEffects',
      text: 'navigation.rotationEffects',
      minimalRole: ROLE_FARMER,
    },
    {
      path: 'exploitation/groundTypesEffects',
      text: 'navigation.groundTypeEffects',
      minimalRole: ROLE_FARMER,
    },
    {
      path: 'exploitation/cultureGroup',
      text: 'navigation.cultureGroup',
      minimalRole: ROLE_FARMER,
    },
    { path: 'exploitation/simulation', text: 'navigation.simulation', minimalRole: ROLE_FARMER },
    { path: 'exploitation/import', text: 'navigation.import', minimalRole: ROLE_FARMER },
  ],
};

export const simulationSteps = [
  { title: 'simulation.step.parcels' },
  { title: 'simulation.step.cultures' },
  { title: 'simulation.step.constraints' },
  { title: 'simulation.step.objectives' },
  { title: 'simulation.step.parcelConstraints' },
  { title: 'simulation.step.summary' },
];

export const colors = [
  '#b71c1c',
  '#d32f2f',
  '#f44336',
  '#e57373',
  '#ffcdd2',
  '#880e4f',
  '#c2185b',
  '#e91e63',
  '#f06292',
  '#f8bbd0',
  '#4a148c',
  '#7b1fa2',
  '#9c27b0',
  '#ba68c8',
  '#e1bee7',
  '#311b92',
  '#512da8',
  '#673ab7',
  '#9575cd',
  '#d1c4e9',
  '#1a237e',
  '#303f9f',
  '#3f51b5',
  '#7986cb',
  '#c5cae9',
  '#0d47a1',
  '#1976d2',
  '#2196f3',
  '#64b5f6',
  '#bbdefb',
  '#01579b',
  '#0288d1',
  '#03a9f4',
  '#4fc3f7',
  '#b3e5fc',
  '#006064',
  '#0097a7',
  '#00bcd4',
  '#4dd0e1',
  '#b2ebf2',
  '#004d40',
  '#00796b',
  '#009688',
  '#4db6ac',
  '#b2dfdb',
  '#194D33',
  '#388e3c',
  '#4caf50',
  '#81c784',
  '#c8e6c9',
  '#33691e',
  '#689f38',
  '#8bc34a',
  '#aed581',
  '#dcedc8',
  '#827717',
  '#afb42b',
  '#cddc39',
  '#dce775',
  '#f0f4c3',
  '#f57f17',
  '#fbc02d',
  '#ffeb3b',
  '#fff176',
  '#fff9c4',
  '#ff6f00',
  '#ffa000',
  '#ffc107',
  '#ffd54f',
  '#ffecb3',
  '#e65100',
  '#f57c00',
  '#ff9800',
  '#ffb74d',
  '#ffe0b2',
  '#bf360c',
  '#e64a19',
  '#ff5722',
  '#ff8a65',
  '#ffccbc',
  '#3e2723',
  '#5d4037',
  '#795548',
  '#a1887f',
  '#d7ccc8',
  '#263238',
  '#455a64',
  '#607d8b',
  '#90a4ae',
  '#cfd8dc',
  '#000000',
  '#525252',
  '#969696',
  '#d9d9d9',
  '#ffffff',
];

export const LOCALE_TRANSLATION = {
  fr: {
    adapterLocale: 'fr',
    localeText: frFR.components.MuiLocalizationProvider.defaultProps.localeText,
  },
  ro: {
    adapterLocale: 'ro',
    localeText: roRO.components.MuiLocalizationProvider.defaultProps.localeText,
  },
  en: {
    adapterLocale: 'en',
    localeText: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
  },
};
